import { styled } from 'linaria/react';
import { css } from 'linaria';

export const Container = styled.div`
  position: relative;
  display: flex;
`;

export const DiscountValue = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(-8deg);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Value = styled.div`
  font-size: 18px;
  color: var(--text-primary-invert);
  font-weight: 700;
  line-height: normal;
  font-style: normal;
  margin-right: var(--space-10);
  margin-left: var(--space-10);
`;

export const rotate = css`
  transform: rotate(8deg);
`;
